import { purchaseBillDeleteApi } from "../../api/purchaseBill/purchaseBillDeleteApi"

type PayloadShape = Parameters<typeof purchaseBillDeleteApi>[0]

export async function purchaseBillDeleteService(payload: PayloadShape, token: string) {
	return await purchaseBillDeleteApi(payload, token)
}
